import { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import PageHeader from '../components/PageHeader';
import CategoriesTab from '../features/settings/components/categories/CategoriesTab';
import OptionsTab from '../features/settings/components/options/OptionsTab';
import MachineTemplatesTab from '../features/settings/components/machineTemplates/MachineTemplatesTab';
import { MACHINE_DATA_PAGE_LABELS as LABELS } from '../utils/labels';
import type { MemberRole } from '../types/roles';

interface MachineDataPageProps {
  orgId: string | null;
  isSuperAdmin: boolean;
  role: MemberRole | null;
}

type Section = 'categories' | 'options' | 'templates';

export default function MachineDataPage({ orgId, isSuperAdmin, role }: MachineDataPageProps) {
  const [section, setSection] = useState<Section>('categories');

  return (
    <div className="h-dvh flex flex-col bg-background">
      <PageHeader />
      <main className="flex-1 overflow-y-auto p-4 md:p-8">
        <div className="max-w-xl mx-auto space-y-6">
          <h1 className="sr-only">{LABELS.title}</h1>
          <Tabs
            value={section}
            onChange={(_, value: Section) => setSection(value)}
            className="border-b border-border"
          >
            <Tab label={LABELS.tabCategories} value="categories" />
            <Tab label={LABELS.tabOptions} value="options" />
            <Tab label={LABELS.tabTemplates} value="templates" />
          </Tabs>

          {section === 'categories' && <CategoriesTab orgId={orgId} isSuperAdmin={isSuperAdmin} role={role} />}
          {section === 'options' && <OptionsTab orgId={orgId} isSuperAdmin={isSuperAdmin} role={role} />}
          {section === 'templates' && <MachineTemplatesTab orgId={orgId} isSuperAdmin={isSuperAdmin} role={role} />}
        </div>
      </main>
    </div>
  );
}
